<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20 blog-posts">
      <!-- <h3>{{page_title}}</h3> -->

      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'Home', params: {}}">{{'Home'|translate}}</router-link>
        </li>
        <li v-if="send_params.category_id || send_params.user_id">
          <router-link :to="{ name: 'AllPosts', params: {  }}">{{'All posts'|translate}}</router-link>
        </li>

        <li
          class="active"
          v-if="!send_params.category_id && !send_params.user_id && page_title "
        >{{'All posts'|translate}}</li>
        <li v-if="send_params.category_id || send_params.user_id" class="active">{{page_title}}</li>
      </ol>

      <div class="row">
        <div class="col-md-9">
          <form class="form-inline" v-on:submit.prevent="formDoSearch">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                v-model="send_params.keyword"
                :placeholder="'Keyword'|translate"
              />
            </div>
            <div class="checkbox">
              <label for="is_official">{{'Is Official'|translate}}:</label>
              <select class="form-control" id="is_official" v-model="send_params.is_official">
                <option value>{{'All'|translate}}</option>
                <option value="1">{{'Yes'|translate}}</option>
                <option value="0">{{'No'|translate}}</option>
              </select>
              &nbsp;
            </div>
            <button type="submit" class="btn btn-primary">
              <i class="fa fa-search" />
              {{'Search'|translate}}
            </button>
          </form>
          <hr />
          <loading v-if="list_items == null" class="mt20" :text="'Please wait'|translate"></loading>
          <p
            class="mt20 alert alert-info"
            v-if="list_items && list_items.length == 0"
          >{{'There is no post'|translate}}</p>
          <div v-if="list_items && list_items.length > 0">
            <div class="row">
              <div class="col-xs-12 col-md-12" v-for="(item) in list_items" :key="item.id">
                <div class="media entry">
                  <div class="media-left">
                    <img :src="item.thumb" class="media-object" style="width:180px" />
                  </div>
                  <div class="media-body">
                    <p class="title">
                      <router-link
                        :to="{ name: 'BlogSinglePost', params: { id: item.id,slug:item.slug }}"
                      >{{item.title}}</router-link>
                    </p>
                    <p class="cat">
                      <i class="fas fa-tag"></i>

                      <router-link
                        :to="{ name: 'BlogCatPosts', params: { cat_id: item.category_id,cat_slug:item.category_slug }}"
                      >{{item.category_name}}</router-link>
                    </p>
                    <p>
                      <i class="fas fa-user"></i>
                      <router-link
                        :to="{ name: 'BlogUserPosts', params: { user_id: item.user_id,user_slug:item.author_slug }}"
                      >{{item.author_name}}</router-link>
                    </p>

                    <p class="time">
                      <i class="fas fa-calendar-alt"></i>
                      {{item.add_date | moment("from", "now") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <paginate
              v-if="total_page > 1"
              :page-count="total_page"
              :click-handler="clickPage"
              :prev-text="'Prev'|translate"
              :next-text="'Next'|translate"
              v-model="page"
              :container-class="'pagination'"
            ></paginate>
          </div>
        </div>
        <div class="col-md-3">
          <div class="panel panel-info">
            <div class="panel-heading">{{'Categories'|translate}}</div>
            <div class="panel-body">
              <ul>
                <li class="mt5" v-for="(item) in categories" :key="item.id">
                  <router-link
                    :to="{ name: 'BlogCatPosts', params: { cat_id: item.id,cat_slug:item.slug }}"
                  >{{item.name}} ({{item.count_posts}})</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Paginate from "vuejs-paginate";
// import FormStore from '@/components/forms/FormStore'

import Loading from "@/components/elements/Loading";
export default {
  name: "Home",
  components: {
    MyHeader,
    Loading,
    Paginate
  },
  data() {
    let data = this.initData();
    return data;
  },
  watch: {
    $route(to, from) {
      console.log("from", from);
      console.log("to", to);
      // this.loadInfo();
      this.init();
    }
  },
  methods: {
    initData() {
      return {
        list_items: null,
        page: 1,
        subject_title: "",
        categories: [],
        page_title: "",
        total_page: 1,
        send_params: {
          offset: 0,
          limit: Utils.getLimit(),
          keyword: "",
          category_id: "",
          is_official: ""
        }
      };
    },
    list() {
      this.list_items = null;
      Utils.request(this, true, "blog")
        .get(`/blogs/?${Utils.arrayToRequestParam(this.send_params)}`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            let list = data.data.list.map(item => {
              let temp = new Date(parseInt(item.add_time) * 1000);
              item.add_date = this.$moment(temp);
              return item;
            });
            this.list_items = list;
            this.total_page = Utils.getTotalPages(
              data.data.count,
              this.send_params.limit
            );
            this.setPageTitle(data.data);
            console.log("this.total_page", this.total_page);
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },

    setPageTitle(data) {
      if (data.category) {
        this.page_title = this.$t("Category");
        this.subject_title = data.category.name;
      } else if (data.user) {
        this.page_title = this.$t("Author");
        this.subject_title = data.user.name;
      }
      this.page_title += ": " + this.subject_title;
    },
    search() {
      console.log("keyword", this.keyword);
      this.list();
    },
    clickPage(pageNum) {
      this.send_params.offset = Utils.getNextOffset(
        pageNum,
        this.send_params.limit
      );
      this.list();
    },
    init() {
      // let data = this.initData();
      // for (let key in data) {
      //   this[key] = data[key];
      // }
      this.page_title = "";
      this.send_params.category_id = this.$route.params.cat_id
        ? this.$route.params.cat_id
        : "";

      this.send_params.user_id = this.$route.params.user_id
        ? this.$route.params.user_id
        : "";

      this.list();
      console.log("this.send_params.category_id", this.send_params.category_id);
      console.log("this.send_params.user_id", this.send_params.user_id);
    },
    listCategories() {
      Utils.request(this, true, "blog")
        .get(`/categories/`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.categories = data.data;
          }
        })
        .catch(error => {
          Utils.showErrorMessage(this, error.response);
        });
    },
    formDoSearch() {
      this.list();
    }
  },
  mounted() {
    this.listCategories();
    this.init();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Blog/BlogPosts.vue